module.exports = __webpack_public_path__ + "media/images/advocating-9d6a68f50b67a9277209bd54e7a013a7.jpg";